import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1915cad9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "group" }
const _hoisted_2 = { class: "viewport" }
const _hoisted_3 = { class: "rel" }
const _hoisted_4 = { class: "addition rel" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "additionTips abs" }
const _hoisted_7 = { class: "s-content box-lg-shadow" }
const _hoisted_8 = { class: "s-content-title" }
const _hoisted_9 = { class: "groupPreview" }
const _hoisted_10 = {
  alt: "",
  class: "productPic"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  alt: "",
  class: "productPic"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "text-rt bottom" }

import { ref, reactive, computed, watch, onMounted, watchEffect } from 'vue'
import GroupForm from './group/GroupForm.vue'
import GroupProducts from './group/GroupProducts.vue'
import GroupImgs from './group/GroupImgs.vue'
import { useRouter, useRoute } from 'vue-router'
import AdtOrder from '@/components/additional/AdtOrder.vue'
import { t } from '@/plugins/i18n'
import useRules, { useMust } from '@/util/useRules'
import { useRequest } from '@/util/useLoading'
import useForm from '@/util/useForm'
import { createGroup, createGpAddCart } from '@/apis/shopcart'
import { ElMessage } from 'element-plus'
import { isJA, useRtfix, getWarehouseCode } from '@/store'
import { useStore } from 'vuex'
import { confirmFinishAdd } from '@/util/useConfirm'
import { setAdt } from '@/util/calcAdt'
import { batchQueryCombinationProduct } from '@/apis/order'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { BASE_IMAGE } from '@/common/baseImage'
import { getAdtList, getIngredients } from '@/apis/addition'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { query } = useRoute()
const store = useStore()
const router = useRouter()
const proxy: any = ref(null)
const isEdit = store.state.goods.CombinedInfo?.combinationProductSku
// watch(proxy.value, () => {
//   console.log(proxy.value)
// })
const {
  combinationProductSku = undefined,
  combinationProductName = '',
  combinationProductProp = '',
  combinationProductItemList = [],
  combinationProductMainImg = '',
  combinationProductAdditionList = [],
  customerProductMsku = '',
  orderFlag = false
} = query.from ? {} : store.state.goods.CombinedInfo ?? {}

const model = reactive({
  combinationProductSku,
  combinationProductName,
  combinationProductProp,
  combinationProductItemList,
  combinationProductMainImg,
  combinationProductAdditionList,
  customerProductMsku
})

const groupList = store.state.goods.groupList
if (query.from && groupList.length) {
  model.combinationProductItemList = groupList.map((v: any) => {
    v.productSkuImg = v.productSkuImg || v.productMainImg
    v.unitNums = 1
    return v
  })
  model.combinationProductMainImg = groupList[0].productSkuImg
}

const rules = {
  combinationProductName: useRules({
    message: t('组合商品名称不能为空'),
    key: 'noblank'
  }),
  combinationProductProp: useRules({
    message: t('组合商品规格不能为空'),
    key: 'noblank'
  }),
  combinationProductMainImg: useMust(
    t('选择一张图片作为组合商品主图'),
    'change'
  )
}
let flag = false
const addCart = () => {
  flag = true
  create()
}

const [loading, api] = useRequest((data: any) => {
  const api = flag ? createGpAddCart : createGroup
  return api(data).then(async (res) => {
    const { success } = res
    if (!success) return
    if (flag) {
      confirmFinishAdd(total.value, '查看组合列表', 'CombinedGoods', model?.combinationProductItemList?.[0]?.goodsCountry)
    } else {
      ElMessage.success(t('创建成功2'))
      router.replace(useRtfix('CombinedGoods'))
    }
    flag = false
    store.commit('goods/CombinedInfo', {})
    store.commit('goods/groupList', [])
  })
})
const total = ref(0)

const [formRef, create] = useForm(async () => {
  const data: any = { ...model }
  total.value = 0
  let num = 0
  if (data.combinationProductItemList.some((i: any) => !i.additionList && i.noAdditionalFlag !== 1)) {
    ElMessage.error({
      dangerouslyUseHTMLString: true,
      message: t('请编辑附加项后保存')
    })
    return false
  }
  data.combinationProductItemList = await Promise.all(
    data.combinationProductItemList.map(async (v: any) => {
      const userSelAdt = v.additionList ? {
        noAdditionalFlag: v.noAdditionalFlag,
        combinationProductItemAdditionList: v.additionList
      } : {
        noAdditionalFlag: 1,
        combinationProductItemAdditionList: []
      }
      num += v.unitNums
      return {
        ...userSelAdt,
        productSku: v.productSku,
        shopProductSku: v.shopProductSku,
        unitNums: v.unitNums
      }
    })
  )
  console.log(data)
  if (num < 2) {
    ElMessage.error(t('子商品总数不能少于2件'))
  } else {
    total.value = num
    api(data)
  }
})

const handleAdt = async (list: any) => {
  console.log(list)
  if (list !== 1) {
    model.combinationProductAdditionList = list.map((v: any) => {
      return {
        ...v,
        customerIngredientsSku: v.ingredientsSku
      }
    })
  } else {
    model.combinationProductAdditionList = []
  }
}

const editIcon = require('@/assets/image/icon/floatrate/edit.png')
const equalIcon = require('@/assets/image/icon/floatrate/equal.png')
const addIcon = require('@/assets/image/icon/floatrate/add.png')
const onShowMainPic = computed(() => {
  return model.combinationProductMainImg ? model.combinationProductMainImg : model.combinationProductItemList.length > 0 ? model.combinationProductItemList[0].productSkuImg || model.combinationProductItemList[0].productMainImg : ''
})

watch(() => model.combinationProductItemList, async (v, old) => {
  if (!(!isEdit || query.from)) return
  if (model.combinationProductItemList.length === 0) {
    // 没有选择商品是组合附加项默认为空
    model.combinationProductAdditionList = []
    return
  }
  //   只能相同国家的商品进行组合，所以直接取第一个元素
  const goodsCountry = model?.combinationProductItemList?.[0]?.goodsCountry
  const oldCountry = old?.[0]?.goodsCountry
  if (oldCountry && goodsCountry === oldCountry) return
  const warehouseCode = getWarehouseCode(goodsCountry === 'KR')
  // 1 普通商品 2 组合商品
  const res = await getAdtList({ productType: 2, warehouseCode })
  const data = res?.data?.productAdditionList?.filter((i: any) => i?.additionCode === 38)
  // console.log(data, 'combinationProductAdditionList')
  // debugger
  model.combinationProductAdditionList = data
  // proxy.value = data
}, { immediate: true })

const chooseAddition = () => {
  if (!model?.combinationProductItemList?.length) {
    ElMessage.warning(t('请先选择子商品'))
    return
  }
  proxy.value = model.combinationProductAdditionList
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            _isRef(formRef) && (formRef.value = _value)
          },
          model: _unref(model),
          rules: rules,
          "label-width": "160px"
        }, {
          default: _withCtx(() => [
            _createVNode(GroupProducts, {
              list: _unref(model).combinationProductItemList,
              "onUpdate:list": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).combinationProductItemList) = $event)),
              isEdit: _unref(isEdit),
              orderFlag: _unref(orderFlag)
            }, null, 8, ["list", "isEdit", "orderFlag"]),
            _createVNode(GroupForm, {
              class: "s-content box-lg-shadow groupForm",
              model: _unref(model),
              orderFlag: _unref(orderFlag)
            }, {
              pics: _withCtx(() => [
                _createVNode(GroupImgs, {
                  img: _unref(model).combinationProductMainImg,
                  "onUpdate:img": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).combinationProductMainImg) = $event)),
                  list: _unref(model).combinationProductItemList,
                  orderFlag: _unref(orderFlag)
                }, null, 8, ["img", "list", "orderFlag"])
              ]),
              addition: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "combinationProductAdditionList",
                  label: _unref(t)('组合商品附加项')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(_unref(model).combinationProductAdditionList.map((v) => v.additionNameJp).join('，')), 1),
                      _createElementVNode("div", {
                        class: "btn abs edit",
                        onClick: chooseAddition
                      }, [
                        _createElementVNode("img", {
                          src: _unref(editIcon),
                          alt: ""
                        }, null, 8, _hoisted_5),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('选择附加项')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('主商品无库存时下直发单，附加项将不执行')), 1)
                    ]),
                    (_openBlock(), _createBlock(_Suspense, null, {
                      default: _withCtx(() => [
                        (proxy.value)
                          ? (_openBlock(), _createBlock(AdditionDrawer, {
                              countryCode: _unref(model).combinationProductItemList?.[0]?.goodsCountry ?? _unref(COUNTRY).CN,
                              key: _unref(model).combinationProductItemList?.[0]?.goodsCountry ?? _unref(COUNTRY).CN,
                              list: proxy.value,
                              "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => ((proxy).value = $event)),
                              isGroup: true,
                              noSpot: true,
                              onCommit: handleAdt,
                              type: "AdtOrder",
                              title: _unref(t)('选择附加项')
                            }, null, 8, ["countryCode", "list", "title"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model", "orderFlag"]),
            _createElementVNode("div", _hoisted_7, [
              (_unref(model).combinationProductItemList.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('最终组合结果')), 1),
                    _createVNode(_component_el_scrollbar, { style: {"margin-left":"157px","height":"160px"} }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: _unref(onShowMainPic) || _unref(BASE_IMAGE),
                              alt: ""
                            }, null, 8, _hoisted_11)
                          ]),
                          _createElementVNode("img", {
                            src: _unref(equalIcon),
                            alt: "",
                            class: "icon"
                          }, null, 8, _hoisted_12),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(model).combinationProductItemList), (p, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: p.productSku
                            }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("img", {
                                  src: p.productSkuImg || p.productMainImg || _unref(BASE_IMAGE),
                                  alt: ""
                                }, null, 8, _hoisted_14),
                                _createElementVNode("span", null, "x" + _toDisplayString(p.unitNums), 1)
                              ]),
                              (i != _unref(model).combinationProductItemList.length - 1)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _unref(addIcon),
                                    alt: "",
                                    class: "icon"
                                  }, null, 8, _hoisted_15))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_button, {
                  type: "default",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).back()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('返回')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: _unref(loading),
                  onClick: _unref(create)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: _unref(loading),
                  onClick: addCart
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('保存并加入购物车')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}
}

})